var map = {
	"./en.json": [
		770,
		11
	],
	"./es-CO.json": [
		771,
		12
	],
	"./fr.json": [
		772,
		13
	],
	"./ko.json": [
		773,
		14
	],
	"./pt-BR.json": [
		774,
		15
	],
	"./th.json": [
		775,
		16
	],
	"./vi.json": [
		776,
		17
	],
	"./zh-CN.json": [
		777,
		18
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 764;
module.exports = webpackAsyncContext;